import React, { Fragment } from 'react';
  
  const Refund_Policy = ({
    isMobile
  }) =>  {
	return (
        /* Box Section */
        <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
            {/* Box Title */}
            <h2 style={{color: 'rgb(228,228,231)', fontWeight: 600, fontSize: '1.5rem', lineHeight: '2rem', margin: 0}}>
                Refund Policy
            </h2>
            <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
                We offer a 24-hour refund policy for our software subscription ONLY in the condition that you are able to show video evidence that it is not working on your computer. Concerns like <a href='/help?section=undetectability' style={{textDecoration: 'underline', color: 'inherit'}}>detection by screen-sharing software</a>, or slowness in solution generation are not refundable.
            </p>
            {/* Numbered List */}
            <div style={{margin: '1rem 0'}}>
                {/* Sub-Title */}
                <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                    How to Request a Refund
                </h2>
                {/* Spacer */}
                <div style={{height: '1rem'}}></div>
                {/* Numbered List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                    {/* Number Circle */}
                    <div style={{borderRadius: '50%', border: '1px solid rgb(63,63,70)', fontSize: '.75rem', width: '1.5rem', height: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        1
                    </div>
                    {/* Text Container */}
                    <div>
                        <p style={{color: '#fff', fontSize: '1rem', margin: '0'}}>
                            Contact Support
                        </p>
                        <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '.25rem 0 0'}}>
                            Your subscription will remain active until the end of your current billing period
                        </p>
                    </div>
                </div>
                {/* Numbered List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.75rem'}}>
                    {/* Number Circle */}
                    <div style={{borderRadius: '50%', border: '1px solid rgb(63,63,70)', fontSize: '.75rem', width: '1.5rem', height: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        2
                    </div>
                    {/* Text Container */}
                    <div>
                        <p style={{color: '#fff', fontSize: '1rem', margin: '0'}}>
                            Provide Details
                        </p>
                        <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '.25rem 0 0'}}>
                            Include your purchase details and proof of the software not working on your machine
                        </p>
                    </div>
                </div>
                {/* Numbered List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.75rem'}}>
                    {/* Number Circle */}
                    <div style={{borderRadius: '50%', border: '1px solid rgb(63,63,70)', fontSize: '.75rem', width: '1.5rem', height: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        3
                    </div>
                    {/* Text Container */}
                    <div>
                        <p style={{color: '#fff', fontSize: '1rem', margin: '0'}}>
                            Processing Time
                        </p>
                        <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '.25rem 0 0'}}>
                            Refunds will be processed within 5-7 business days
                        </p>
                    </div>
                </div>
            </div>
        </div>
	  
	);
  }
  
  export default Refund_Policy;
  